import { http } from '@/api/client/httpClient';
import type { PagedResult } from '@/api/types/abp';
import type {
  PricesAndVolumesDto,
  QuickStressTestConfigurationDto,
  ReverseStopOutInputDto,
  ReverseStopOutResultDto,
  StressTestInputDto,
  StressTestResultDto,
} from '@/api/types/nopStressTest';

const BASE = '/api/app/nop-stress-test';

// The snapshot/take-snapshot endpoints wrap the filters DTO: { filters: {...} }.
// Legacy only sends the fields that are actually set, so strip null/empty keys
// (sending extra null fields made the POST body fail model binding → 400).
function compact(filters: StressTestInputDto['filters']): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  Object.entries(filters as unknown as Record<string, unknown>).forEach(([k, v]) => {
    if (v != null && v !== '') out[k] = v;
  });
  return out;
}
// GetSnapshot is GET, so the nested object is flattened to filters.* query keys.
function flattenFilters(filters: StressTestInputDto['filters']): Record<string, unknown> {
  const out: Record<string, unknown> = {};
  Object.entries(compact(filters)).forEach(([k, v]) => { out[`filters.${k}`] = v; });
  return out;
}

export const nopStressTestApi = {
  runStressTest: (input: StressTestInputDto) => http.post<StressTestResultDto>(`${BASE}/run-stress-test`, { filters: compact(input.filters), configuration: input.configuration }).then((r) => r.data),
  getSnapshot: (filters: StressTestInputDto['filters']) => http.get<StressTestResultDto>(`${BASE}/snapshot`, { params: flattenFilters(filters) }).then((r) => r.data),
  takeSnapshot: (filters: StressTestInputDto['filters']) => http.post<StressTestResultDto>(`${BASE}/take-snapshot`, { filters: compact(filters) }).then((r) => r.data),
  getPricesAndVolumes: () => http.get<PricesAndVolumesDto[]>(`${BASE}/prices-and-volumes`).then((r) => r.data),
  getQuickConfigurations: () => http.get<QuickStressTestConfigurationDto[]>(`${BASE}/quick-stress-test-configurations`).then((r) => r.data),
  calculateReverseStopOut: (input: ReverseStopOutInputDto) => http.post<ReverseStopOutResultDto>(`${BASE}/calculate-reverse-stop-out`, input).then((r) => r.data),
  getLoginsForReverseStopOut: (search: string, skipCount: number, maxResultCount: number) =>
    http.get<PagedResult<{ value: string; text: string }>>(`${BASE}/logins-for-reverse-stop-out`, { params: { search, skipCount, maxResultCount } }).then((r) => r.data),
};
